<template>
  <v-dialog
    v-model="dialog"
    width="448"
    open-on-focus
    no-click-animation
    persistent
    content-class="sequence-assigned-dialog"
    @click:outside="onClickOutside"
    @keydown="onKeydown"
  >
    <v-card elevation="0">
      <div class="sequence-assigned-form-body">
        <v-toolbar flat height="76">
          <v-toolbar-title class="sequence-assigned-toolbar-title"
            >Assigned participants</v-toolbar-title
          >
          <v-spacer></v-spacer>
          <v-btn color="accent" icon tile @click="closeDialog">
            <v-icon size="24">mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-container class="new-practice-card-container pt-4">
          <v-overlay v-if="isLoading" :value="isLoading" z-index="4">
            <v-progress-circular indeterminate size="64" />
          </v-overlay>
          <div class="sequence-assigned-patients">
            <main-user-table
              :headers="headers"
              :items="items"
              :items-per-page="999"
              :server-items-length="999"
              :page="1"
              :show-all-items="true"
              :hide-default-footer="true"
              :row-component="'sequence-assigned-participant-table-row'"
            />
          </div>
        </v-container>
      </div>
      <div class="sequence-assigned-footer">
        <v-container class="pt-0 pb-4">
          <v-row>
            <v-col class="text-right"> </v-col>
          </v-row>
        </v-container>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'

import MainUserTable from '@/components/tables/MainUserTable'
import RouterMixin from '@/mixins/router'
import { debounce } from '@/helpers/debounce'

export default {
  name: 'SequenceAssignedDialog',
  components: {
    MainUserTable,
  },
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
    showDialog: {
      type: Boolean,
      default: false,
    },
    assignedParticipants: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      dialog: false,
      headers: [],
    }
  },
  watch: {
    showDialog: function(val) {
      if (val) {
        this.dialog = true
      }
    },
  },
  computed: {
    ...mapState('profilePreviewsStates', ['profilePreviews']),
    items() {
      return this.assignedParticipants.map(participant => {
        const found = this.profilePreviews.find(
          profile => participant.profileId === profile.profileId,
        )
        return found || participant
      })
    },
  },
  methods: {
    getData(data = {}) {},
    closeDialog() {
      this.dialog = false
      this.$emit('close-dialog')
    },
    onClickOutside() {
      this.closeDialog()
    },
    onKeydown(key) {
      if (key.code === 'Escape' && key.isTrusted) this.closeDialog()
    },
  },
}
</script>

<style lang="scss">
@import '@/styles/variables.scss';

.sequence-assigned {
  &-dialog {
    margin: $gutter;
    margin-left: auto;
    height: 100%;
    max-height: calc(100% - #{2 * $gutter}) !important;
    // looks little hacky
    > .v-card {
      width: 100%;
      height: 100%;
      background-color: $bh-blue--4;
      overflow: auto;
    }
    .dialog-select.filter {
      flex-grow: 0;
      max-width: 180px;
      margin-right: 8px;
    }
  }
  &-toolbar-title {
    color: $bh-blue;
    font-weight: bold;
  }
  &-tabs {
    padding: 0 24px;
    background: #ffffff;
    .v-tab {
      color: $bh-blue;
      text-transform: none;
      letter-spacing: 0;
      font-size: 1em;
      &:not(.v-tab--active) {
        color: white;
      }
    }
    .v-tabs-slider {
      background: $bh-blue;
    }
  }
  &-v-tabs-items {
    background: $bh-blue--4 !important;
  }

  &-card {
    &-title {
      font-size: $font-size-root;
      color: $bh-blue;
      padding-left: 1.5 * $gutter;
      padding-right: 1.5 * $gutter;
    }
    &-container {
      padding-left: 1.5 * $gutter;
      padding-right: 1.5 * $gutter;
    }
    &-footer {
      padding: 1.5 * $gutter;
    }
  }
  &-form {
    height: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-height: 0;
    &-body {
      ::v-deep .v-toolbar__content {
        padding-left: 1.5 * $gutter;
        padding-right: 1.5 * $gutter;
      }
    }
    &-col-left {
      padding-top: 0;
      padding-right: 0.25 * $gutter;
    }
    &-col-right {
      padding-top: 0;
      padding-left: 0.25 * $gutter;
    }
  }
  &-user-patients {
    padding: 12px 24px;
  }
}
</style>
